import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M7.5 3.25C6.25736 3.25 5.25 4.25736 5.25 5.5V18.5C5.25 19.7426 6.25736 20.75 7.5 20.75H10.5C10.9142 20.75 11.25 21.0858 11.25 21.5C11.25 21.9142 10.9142 22.25 10.5 22.25H7.5C5.42893 22.25 3.75 20.5711 3.75 18.5V5.5C3.75 3.42893 5.42893 1.75 7.5 1.75H16.5C18.5711 1.75 20.25 3.42893 20.25 5.5V6.75C20.25 7.16421 19.9142 7.5 19.5 7.5C19.0858 7.5 18.75 7.16421 18.75 6.75V5.5C18.75 4.25736 17.7426 3.25 16.5 3.25H7.5ZM18.313 15.8903C19.0342 15.3424 19.4999 14.4756 19.4999 13.5C19.4999 11.8431 18.1568 10.5 16.4999 10.5C14.8431 10.5 13.4999 11.8431 13.4999 13.5C13.4999 14.4756 13.9656 15.3424 14.6868 15.8903C14.6956 15.8967 14.7043 15.9032 14.7128 15.9099C15.212 16.2806 15.8303 16.5 16.4999 16.5C17.1695 16.5 17.7878 16.2806 18.287 15.9099C18.2955 15.9032 18.3042 15.8967 18.313 15.8903ZM19.4999 16.8542C20.4205 16.0302 20.9999 14.8327 20.9999 13.5C20.9999 11.0147 18.9852 9 16.4999 9C14.0146 9 11.9999 11.0147 11.9999 13.5C11.9999 14.8327 12.5793 16.0302 13.4999 16.8542V21.6113C13.4999 22.1914 14.0683 22.6011 14.6187 22.4176L16.4999 21.7906L18.3811 22.4176C18.9315 22.6011 19.4999 22.1914 19.4999 21.6113V16.8542ZM17.9999 17.7439C17.5307 17.9098 17.0259 18 16.4999 18C15.974 18 15.4691 17.9098 14.9999 17.7439V20.7094L16.2311 20.299C16.4056 20.2409 16.5942 20.2409 16.7687 20.299L17.9999 20.7094V17.7439Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
